import React from "react";
import "./HomeCard.css";
import Typewriter from "typewriter-effect";

const HomeCard = () => {
  return (
    <div className="container home-info shadow-lg text-link-color">
      <div className="homeInfo-main">
        <div className="row">
          <div className="col-md-4">
            <div className="black-color home-card-left text-link-color">
              <h5 className="black-color text-link-color">Personal Details</h5>
              <hr className=""></hr>
              <p>
                Email:{" "}
                <span>
                  <a
                    style={{ textDecoration: "none", color: "#45d1cc" }}
                    href="mailto:ehsanmaruf489@gmail.com"
                  >
                    ehsanmaruf489@gmail.com
                  </a>
                </span>
              </p>
              <p>Address: Kuril,Vatara,Dhaka-1229</p>
            </div>
          </div>
          <div className="col-md-8 d-flex align-items-center">
            <div className="">
              <h4 className="">
                <span className="text-link-color">I'm a,</span>
                <span style={{ color: "#45d1cc" }}>
                  {" "}
                  <Typewriter
                    options={{
                      strings: [
                        "Programar..",
                        "Full Stack Web Developer..",
                        "JavaScript Developer..",
                        "MERN Stack developer..",
                      ],
                      autoStart: true,
                      loop: true,
                    }}
                  />
                </span>
              </h4>
              <p className="text-link-color">
                Who is passionate to develop and enhance user-centered websites
                and applications. Creative and logical when crafting effective
                websites. I keep myself organized and make sure to prepare ahead so
                I can effectively manage my time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeCard;
